<script setup>
import { ref, onMounted } from "vue";
import { useDevice } from "@/composables/useDeviceType";
const { deviceType, windowWidth, windowHeight } = useDevice();
const UA = ref(navigator.userAgent);
</script>
<template>
  <div class="header d-none">
    <h5 class="device-type position-fixed top-0 start-0 p-2">
      {{ deviceType }} || {{ UA }}
    </h5>
  </div>
</template>
<style lang="scss" scoped>
.device-type {
  z-index: 99999;
  background-color: rgba($color: #fff, $alpha: 0.5);
}
</style>
